var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      directives: [
        {
          name: "show",
          rawName: "v-show",
          value: _vm.isShow,
          expression: "isShow"
        }
      ],
      staticClass: "popup"
    },
    [
      _vm.isVIP && _vm.isIns ? _c("upgradeVipInnerInsDialog") : _vm._e(),
      _vm._v(" "),
      _vm.isVIP && !_vm.isIns ? _c("upgradeVipInnerTrafficDialog") : _vm._e(),
      _vm._v(" "),
      !_vm.isVIP
        ? _c("div", { staticClass: "content free_to_vip_popup" }, [
            _c("div", { staticClass: "popup_title" }, [
              _c("div", { staticClass: "popup_title_bg" }),
              _vm._v(" "),
              _c("div", { staticClass: "popup_title_content" }, [
                _c("div", { staticClass: "popup_title_main" }, [
                  _vm._v(_vm._s(_vm.title))
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "popup_title_sub" }, [
                  _vm._v(
                    _vm._s(_vm.$t("language.paySystem.freePlanPopup.desc"))
                  )
                ]),
                _vm._v(" "),
                _c("div", {
                  staticClass: "popup_title_close",
                  on: {
                    click: function($event) {
                      _vm.isShow = !_vm.isShow
                    }
                  }
                })
              ])
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "popup_content" }, [
              _c(
                "div",
                { staticClass: "popup_content_item popup_content_item_head" },
                [
                  _c("div", { staticClass: "popup_content_item1" }, [
                    _c("div", { staticClass: "popup_content_item_sub" }, [
                      _vm._v(
                        _vm._s(
                          _vm.$t(
                            "language.paySystem.freePlanPopup.itemTitle_th"
                          )
                        )
                      )
                    ])
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "popup_content_item2" }, [
                    _c("div", { staticClass: "popup_content_item_sub1" }, [
                      _vm._v(
                        _vm._s(
                          _vm.$t(
                            "language.paySystem.freePlanPopup.itemValue_cur"
                          )
                        )
                      )
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "popup_content_item_sub2" }, [
                      _vm._v(
                        _vm._s(
                          _vm.$t(
                            "language.paySystem.freePlanPopup.itemValue_free"
                          )
                        )
                      )
                    ])
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "popup_content_item3" }, [
                    _c("div", { staticClass: "popup_content_item_sub1" }, [
                      _vm._v(
                        _vm._s(
                          _vm.$t(
                            "language.paySystem.freePlanPopup.itemValue_upgrade"
                          )
                        )
                      )
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "popup_content_item_sub2" }, [
                      _vm._v(
                        _vm._s(
                          _vm.$t(
                            "language.paySystem.freePlanPopup.itemvalue_premium"
                          )
                        )
                      )
                    ])
                  ])
                ]
              ),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass: "popup_content_item",
                  class: _vm.curItem == "traffic" ? "select" : ""
                },
                [
                  _c("div", { staticClass: "popup_content_item1" }, [
                    _vm._v(
                      _vm._s(
                        _vm.$t(
                          "language.paySystem.freePlanPopup.itemTitle_traffic"
                        )
                      )
                    )
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "popup_content_item2" }, [
                    _vm._v(
                      _vm._s(
                        _vm.$t("language.paySystem.freePlanPopup.itemvalue_5gb")
                      )
                    )
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "popup_content_item3" }, [
                    _vm._v(
                      _vm._s(
                        _vm.$t(
                          "language.paySystem.freePlanPopup.itemvalue_maxUnlimited"
                        )
                      )
                    )
                  ])
                ]
              ),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass: "popup_content_item",
                  class: _vm.curItem == "pdf" ? "select" : ""
                },
                [
                  _c("div", { staticClass: "popup_content_item1" }, [
                    _vm._v(
                      _vm._s(
                        _vm.$t("language.paySystem.freePlanPopup.itemTitle_pdf")
                      )
                    )
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "popup_content_item2" }, [
                    _vm._v(
                      _vm._s(
                        _vm.$t(
                          "language.paySystem.freePlanPopup.itemvalue_50emails"
                        )
                      )
                    )
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "popup_content_item3" }, [
                    _vm._v(
                      _vm._s(
                        _vm.$t(
                          "language.paySystem.freePlanPopup.itemvalue_unlimited"
                        )
                      )
                    )
                  ])
                ]
              ),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass: "popup_content_item",
                  class: _vm.curItem == "modes" ? "select" : ""
                },
                [
                  _c("div", { staticClass: "popup_content_item1" }, [
                    _vm._v(
                      _vm._s(
                        _vm.$t(
                          "language.paySystem.freePlanPopup.itemTitle_modes"
                        )
                      )
                    )
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "popup_content_item2" }, [
                    _vm._v("4")
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "popup_content_item3" }, [
                    _vm._v("10")
                  ])
                ]
              ),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass: "popup_content_item",
                  class: _vm.curItem == "remote" ? "select" : ""
                },
                [
                  _c("div", { staticClass: "popup_content_item1" }, [
                    _vm._v(
                      _vm._s(
                        _vm.$t(
                          "language.paySystem.freePlanPopup.itemTitle_remote"
                        )
                      )
                    )
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "popup_content_item2" }, [
                    _vm._v("1")
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "popup_content_item3" }, [
                    _vm._v("5")
                  ])
                ]
              ),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass: "popup_content_item",
                  class: _vm.curItem == "subtasks" ? "select" : ""
                },
                [
                  _c("div", { staticClass: "popup_content_item1" }, [
                    _vm._v(
                      _vm._s(
                        _vm.$t(
                          "language.paySystem.freePlanPopup.itemTitle_subtasks"
                        )
                      )
                    )
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "popup_content_item2" }, [
                    _vm._v("3")
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "popup_content_item3" }, [
                    _vm._v("1000")
                  ])
                ]
              ),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass: "popup_content_item",
                  class: _vm.curItem == "scheduled" ? "select" : ""
                },
                [
                  _c("div", { staticClass: "popup_content_item1" }, [
                    _vm._v(
                      _vm._s(
                        _vm.$t(
                          "language.paySystem.freePlanPopup.itemTitle_scheduled"
                        )
                      )
                    )
                  ]),
                  _vm._v(" "),
                  _vm._m(0),
                  _vm._v(" "),
                  _vm._m(1)
                ]
              ),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass: "popup_content_item",
                  class: _vm.curItem == "speed" ? "select" : ""
                },
                [
                  _c("div", { staticClass: "popup_content_item1" }, [
                    _vm._v(
                      _vm._s(
                        _vm.$t(
                          "language.paySystem.freePlanPopup.itemTitle_speed"
                        )
                      )
                    )
                  ]),
                  _vm._v(" "),
                  _vm._m(2),
                  _vm._v(" "),
                  _vm._m(3)
                ]
              ),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass: "popup_content_item",
                  class: _vm.curItem == "sync" ? "select" : ""
                },
                [
                  _c("div", { staticClass: "popup_content_item1" }, [
                    _vm._v(
                      _vm._s(
                        _vm.$t(
                          "language.paySystem.freePlanPopup.itemTitle_sync"
                        )
                      )
                    )
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "popup_content_item2" }, [
                    _vm._v("1")
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "popup_content_item3" }, [
                    _vm._v("2")
                  ])
                ]
              ),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass: "popup_content_item",
                  class: _vm.curItem == "real" ? "select" : ""
                },
                [
                  _c("div", { staticClass: "popup_content_item1" }, [
                    _vm._v(
                      _vm._s(
                        _vm.$t(
                          "language.paySystem.freePlanPopup.itemTitle_real"
                        )
                      )
                    )
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "popup_content_item2" }, [
                    _vm._v("1")
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "popup_content_item3" }, [
                    _vm._v("2")
                  ])
                ]
              ),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass: "popup_content_item",
                  class: _vm.curItem == "filter" ? "select" : ""
                },
                [
                  _c("div", { staticClass: "popup_content_item1" }, [
                    _vm._v(
                      _vm._s(
                        _vm.$t(
                          "language.paySystem.freePlanPopup.itemTitle_filter"
                        )
                      )
                    )
                  ]),
                  _vm._v(" "),
                  _vm._m(4),
                  _vm._v(" "),
                  _vm._m(5)
                ]
              ),
              _vm._v(" "),
              _c("div", { staticClass: "popup_content_item" }, [
                _c("div", { staticClass: "popup_content_item1" }, [
                  _vm._v(
                    _vm._s(
                      _vm.$t("language.paySystem.freePlanPopup.itemTitle_tran")
                    )
                  )
                ]),
                _vm._v(" "),
                _vm._m(6),
                _vm._v(" "),
                _vm._m(7)
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "popup_content_item" }, [
                _c("div", { staticClass: "popup_content_item1" }, [
                  _vm._v(
                    _vm._s(
                      _vm.$t(
                        "language.paySystem.freePlanPopup.itemTitle_customer"
                      )
                    )
                  )
                ]),
                _vm._v(" "),
                _vm._m(8),
                _vm._v(" "),
                _vm._m(9)
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "popup_content_item" }, [
                _c("div", { staticClass: "popup_content_item1" }, [
                  _vm._v(
                    _vm._s(
                      _vm.$t(
                        "language.paySystem.freePlanPopup.itemTitle_watermark"
                      )
                    )
                  )
                ]),
                _vm._v(" "),
                _vm._m(10),
                _vm._v(" "),
                _vm._m(11)
              ])
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "popup_button_box" }, [
              _c(
                "div",
                { staticClass: "popup_button", on: { click: _vm.switchToPay } },
                [
                  _c("img", {
                    attrs: {
                      src: require("../../../assets/images/imageSaver/upgradeCar.svg")
                    }
                  }),
                  _vm._v(" "),
                  _c("span", [
                    _vm._v(
                      _vm._s(_vm.$t("language.paySystem.freePlanPopup.button"))
                    )
                  ])
                ]
              )
            ])
          ])
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "popup_content_item2" }, [
      _c("img", {
        attrs: {
          src: require("../../../assets/images/imageSaver/upgradeSupportNo.svg")
        }
      })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "popup_content_item3" }, [
      _c("img", {
        attrs: {
          src: require("../../../assets/images/imageSaver/upgradeSupportYes.svg")
        }
      })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "popup_content_item2" }, [
      _c("img", {
        attrs: {
          src: require("../../../assets/images/imageSaver/upgradeSupportSpeedGrey.svg")
        }
      })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "popup_content_item3" }, [
      _c("img", {
        attrs: {
          src: require("../../../assets/images/imageSaver/upgradeSupportSpeedOrange.svg")
        }
      }),
      _vm._v(" "),
      _c("img", {
        attrs: {
          src: require("../../../assets/images/imageSaver/upgradeSupportSpeedOrange.svg")
        }
      }),
      _vm._v(" "),
      _c("img", {
        attrs: {
          src: require("../../../assets/images/imageSaver/upgradeSupportSpeedOrange.svg")
        }
      }),
      _vm._v(" "),
      _c("img", {
        attrs: {
          src: require("../../../assets/images/imageSaver/upgradeSupportSpeedOrange.svg")
        }
      }),
      _vm._v(" "),
      _c("img", {
        attrs: {
          src: require("../../../assets/images/imageSaver/upgradeSupportSpeedOrange.svg")
        }
      })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "popup_content_item2" }, [
      _c("img", {
        attrs: {
          src: require("../../../assets/images/imageSaver/upgradeSupportNo.svg")
        }
      })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "popup_content_item3" }, [
      _c("img", {
        attrs: {
          src: require("../../../assets/images/imageSaver/upgradeSupportYes.svg")
        }
      })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "popup_content_item2" }, [
      _c("img", {
        attrs: {
          src: require("../../../assets/images/imageSaver/upgradeSupportNo.svg")
        }
      })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "popup_content_item3" }, [
      _c("img", {
        attrs: {
          src: require("../../../assets/images/imageSaver/upgradeSupportYes.svg")
        }
      })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "popup_content_item2" }, [
      _c("img", {
        attrs: {
          src: require("../../../assets/images/imageSaver/upgradeSupportNo.svg")
        }
      })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "popup_content_item3" }, [
      _c("img", {
        attrs: {
          src: require("../../../assets/images/imageSaver/upgradeSupportYes.svg")
        }
      })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "popup_content_item2" }, [
      _c("img", {
        attrs: {
          src: require("../../../assets/images/imageSaver/upgradeSupportNo.svg")
        }
      })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "popup_content_item3" }, [
      _c("img", {
        attrs: {
          src: require("../../../assets/images/imageSaver/upgradeSupportYes.svg")
        }
      })
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-82ecdb34", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-82ecdb34","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/popup/upgrade_popups/upgrade_account_new_popup.vue
// module id = null
// module chunks = 